import React, { Component } from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from './Helmet';

const Title = 'CircleCI Case Study | Canny';
const Description =
  'Read about how CircleCI uses Canny as their home for feedback to inform their product decisions.';
const Image = 'https://canny.io/images/helmet-cci-case-study.jpg';
const CircleciUrl = 'https://canny.io/case-studies/circleci';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${CircleciUrl}#webpage`,
    url: CircleciUrl,
    name: 'Case Study: CircleCI × Canny',
    description:
      'How CircleCI uses Canny as their home for feedback to inform their product decisions.',
    inLanguage: 'en',
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createArticle('Article', {
    '@id': `${CircleciUrl}#article`,
    genre: 'Case Study',
    headline:
      'How CircleCI uses Canny as their home for feedback to inform their product decisions',
    description:
      'CircleCI consolidated feedback from internal teams, preview users, and public boards into Canny—a single source of truth used daily by PMs, support, and engineering. With over 30,000 votes since 2020, the tool drives strategic product decision-making.',
    inLanguage: 'en',
    url: CircleciUrl,
    mainEntityOfPage: { '@id': `${CircleciUrl}#webpage` },
    author: {
      '@type': 'Organization',
      '@id': 'https://canny.io/#organization',
      name: 'Canny',
      url: 'https://canny.io',
    },
    publisher: { '@type': 'Organization', '@id': 'https://canny.io/#organization' },
    about: { '@type': 'Organization', name: 'CircleCI', url: 'https://circleci.com' },
  }),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Case Studies', item: 'https://canny.io/case-studies' },
    { name: 'CircleCI', item: CircleciUrl },
  ]),
]);

export default class CCILandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: CircleciUrl },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}>
        <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
      </Helmet>
    );
  }
}
